import { Link } from 'react-router-dom'
import { Section } from '@/components/ui/Section'
import { Container } from '@/components/ui/Container'
import { DecoratedHeader } from '@/components/ui/DecoratedHeader'
import { NailsInMotionStrip } from '@/components/gallery/NailsInMotionStrip'
import { nailsInMotionVideos } from '@/content/nailsInMotionVideos'

export function HomeSocialGallery() {
  if (nailsInMotionVideos.length === 0) return null

  return (
    <Section className="bg-sage-wash/30">
      <Container>
        <DecoratedHeader
          size="section"
          eyebrow="Salon"
          eyebrowAccent="Clips"
          title="Nails in motion"
          description="Short autoplay previews from the salon. Open the gallery for still photography."
          sparkle={false}
        >
        </DecoratedHeader>
        <div className="mt-8">
          <NailsInMotionStrip />
        </div>
        <Link to="/gallery" className="link-modern mt-2 inline-block">
            See full gallery
          </Link>
      </Container>
    </Section>
  )
}
